import script from "./DSEmptyState.vue?vue&type=script&setup=true&lang=ts"
export * from "./DSEmptyState.vue?vue&type=script&setup=true&lang=ts"

import "./DSEmptyState.vue?vue&type=style&index=0&id=fd09c566&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd09c566"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
